import {User} from "./user";
import {Service} from "./service";
import {Resource} from "./resource";
import {Reservation} from "./reservation";
import {GroupActivity} from "./groupActivity";

export class ReservationData {
    id: string;
    customer: User;
    service: Service;
    startDate: string;
    endDate: string;
    name: string;
    description: string;
    reservedResources: Resource[];
    reservedUsers: User[];
    reservations: Reservation[];
    createdBy: string;
    updatedBy: string;
    blockedTimeBeforeService: number;
    blockedTimeAfterService: number;
    breakTimeInService: number;
    groupActivity?: GroupActivity;
    completed: boolean;
}
